<template>
  <blockquote
    class="quote">
    <h4
      v-if="size === 'med'"
      v-html="quote"></h4>
    <h5
      v-else
      v-html="quote"></h5>
  </blockquote>
</template>

<script>
export default {
  name: 'Quote',
  props: {
    quote: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.quote {
  width:100%;
  background-color: $grey;
  padding: $page-padding 0;
  margin: $page-padding 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: $radius;
  p, h4, h5 {
    // color: #fff;
    max-width:90%;
    text-align: center;
  }

  @media screen and (max-width: $mobile) {
    margin: 0 0;
  }
}
</style>
